import { render, staticRenderFns } from "./ABuscarEstudiante.vue?vue&type=template&id=5ee0d4cc"
import script from "./ABuscarEstudiante.vue?vue&type=script&lang=js"
export * from "./ABuscarEstudiante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports